import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const ViewAppointments = MatxLoadable({
    loader: () =>
        import ("./ViewAppointments")
})
const AllViewAppointments = MatxLoadable({
    loader: () =>
        import ("./AllViewAppointments")
})




// const settings = {
//     activeLayout: "layout1",
//     layout1Settings: {
//         topbar: {
//             show: false
//         },
//         leftSidebar: {
//             show: false,
//             mode: "close"
//         }
//     },
//     layout2Settings: {
//         mode: "full",
//         topbar: {
//             show: false
//         },
//         navbar: { show: false }
//     },
//     secondarySidebar: { show: false },
//     footer: { show: false }
// };

const ViewAppointmentRoutes = [
    {
        path: "/view_appointment",
        component: AllViewAppointments,
        // settings
    },

];

export default ViewAppointmentRoutes;